<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style>
  * {
    margin: 0;
    padding: 0;
  }
  html, body {
    background-color: #eeeeee;
    height: 100%;
  }
  #app {
    overflow-y:hidden;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue